module.exports = __webpack_public_path__ + "static/media/residentialPortfolioLandingImage.b278eebb.png";